import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import { ImageModule } from "../../common/Image_Module";
import { AltSiteName, TeamBaseURL, ContactFormURL } from "../../utils";
import "./Team.scss"

const TeamListFilter = (props) => {
  const ImageRenderList = ({ image_url, item }) => {
    return (
      <ImageModule ImageSrc={item.Staff_Image} ggfx_results={item.ggfx_results} altText={item.Staff_Image.alternativeText ? item.Staff_Image.alternativeText : item.Name + ' - ' + item.Designation} strapi_id={item.id} imagename={"teams.Staff_Image.commontile"} />
    )
  }
  return (
    <React.Fragment>

      <div className="team-slider row">
        {props.teams && props.teams.length > 0 && props.teams.filter(list => list?.Select_Office.map(c => c.URL).includes(props.Teamfilter)).map((item, index) => {
          return <>
            <div className="team-item col-md-6 col-lg-3">
              {/* <Link to={`${TeamBaseURL}/${item.URL}`} className="img-zoom"> */}
              {/* <ImageRenderList image_url={item.Staff_Image.url} item={item} /> */}
              <div className="img-zoom">
                <img src={item.Staff_Image.url} alt={item.Staff_Image && item.Staff_Image.alternativeText ? item.Staff_Image.alternativeText : item.Name + ' - ' + item.Designation + AltSiteName} />
              </div>
              {/* </Link> */}
              <div className="team-block">
                <span className="date-text">{item.Name}</span>
                <span className="profile">{item.Designation}</span>
                <Link to={`${ContactFormURL}?tid=${item.id}`} className="mail">Send an email</Link>
              </div>
            </div>
          </>
        })}
      </div>
    </React.Fragment>
  )
}
export default TeamListFilter
